import * as types from "../action-types";
import { getToken } from "@/utils/auth";
import { getUser } from "@/utils/localStorage";
const initUserInfo = {
  token: '',
  profile: getUser()
};
export default function user(state = initUserInfo, action) {
  switch (action.type) {
    case types.USER_SET_USER_INFO:
      return {
        ...state,
        token: action.token,
        profile: action.profile
      };
    case types.USER_RESET_USER:
      return {};
    default:
      return state;
  }
}
